import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const AppDownloadBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const path = "https://irangardi.app/download/irangardi-2.0.34-site.apk";
  useEffect(() => {
    const isAndroidMobile = /Android/i.test(navigator.userAgent);
    const hasDismissed = localStorage.getItem("dismissAppBanner");
    if (isAndroidMobile && !hasDismissed) {
      setShowBanner(true);
    }
  }, []);

  const handleClose = () => {
    setShowBanner(false);
    localStorage.setItem("dismissAppBanner", "true");
  };

  if (!showBanner) return null;

  return (
    <div className="fixed top-0 left-0 w-full download-app text-white  px-2 py-3 z-50 shadow-md">
      <div className="flex items-center gap-4 flex-1 overflow-x-auto">
        <span className="whitespace-nowrap text-sm font-medium">
          اپلیکیشن ایران‌گردی رو نصب کن
        </span>
      </div>
      <div>
        <a
          onClick={() => localStorage.setItem("dismissAppBanner", "true")}
          href={`${path}`}
          className="text-white text-sm font-medium whitespace-nowrap ps-1 hover:text-gray-300 transition"
        >
          دانلود
        </a>

        <span
          onClick={handleClose}
          className="text-white hover:text-gray-300 bg-transparent download-link"
          aria-label="بستن"
        >
          <X size={18} />
        </span>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
